// Per-business brand theming for the web app.
// Dark editorial theme mirroring the mobile app: deep midnight navy for
// Baking Jay's, deep ruby for Ruby's, with warm gold CTAs/accents.

export const BUSINESS_IDS = ["baking_jays", "rubys"];

export const THEMES = {
  baking_jays: {
    id: "baking_jays",
    name: "Blue Dragon's Treats",
    tagline: "Baked with fire, finished with gold.",
    focus: "pastries",
    kind: "Bakery",
    logo: "/crest-baking-jays.png",
    vars: {
      "--bg": "#050814",
      "--surface": "#10162B",
      "--surface-2": "#1A223D",
      "--ink": "#F8F9FA",
      "--muted": "#94A3B8",
      "--border": "#2A2C42",
      "--gold": "#F0C75E",
      // gold is the primary interactive colour on dark; text on it is near-black
      "--brand": "#F0C75E",
      "--brand-2": "#E5C07B",
      "--brand-fg": "#1A1400",
      // light text for hero / sidebar surfaces (dark gradients)
      "--hero-fg": "#F8F9FA",
      "--accent": "#F0C75E",
      "--accent-soft": "#253154",
      "--hero-from": "#0C1730",
      "--hero-to": "#22345D",
    },
  },
  rubys: {
    id: "rubys",
    name: "Ruby's Catering",
    tagline: "Hot food, warm hospitality.",
    focus: "hot_food",
    kind: "Catering",
    logo: "/crest-rubys.png",
    vars: {
      "--bg": "#1A0508",
      "--surface": "#2A0A10",
      "--surface-2": "#3A1218",
      "--ink": "#FFF8E7",
      "--muted": "#C9A9A9",
      "--border": "#5A2028",
      "--gold": "#F0C75E",
      "--brand": "#F0C75E",
      "--brand-2": "#E5C07B",
      "--brand-fg": "#3A1218",
      "--hero-fg": "#FFF8E7",
      "--accent": "#F0C75E",
      "--accent-soft": "#4A1620",
      "--hero-from": "#560812",
      "--hero-to": "#8C1B2B",
    },
  },
};

export function getTheme(businessId) {
  return THEMES[businessId] || THEMES.baking_jays;
}

export function applyTheme(businessId) {
  const theme = getTheme(businessId);
  const root = document.documentElement;
  Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
  root.setAttribute("data-business", theme.id);
}
